"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DropdownIndicator = void 0;

var _react = _interopRequireDefault(require("react"));

var _reactSelect = require("react-select");

var _propTypes = _interopRequireDefault(require("prop-types"));

var _Icon = _interopRequireDefault(require("../icon/Icon"));

var DropdownIndicator = function DropdownIndicator(props) {
  var menuIsOpen = props.selectProps.menuIsOpen;
  return /*#__PURE__*/_react["default"].createElement(_reactSelect.components.DropdownIndicator, props, /*#__PURE__*/_react["default"].createElement(_Icon["default"], {
    iconName: menuIsOpen ? 'UpperArrow' : 'DownArrow',
    size: 18,
    mr: "6px",
    className: "eui-dd-indicator"
  }));
};

exports.DropdownIndicator = DropdownIndicator;
DropdownIndicator.propTypes = {
  selectProps: _propTypes["default"].shape({
    menuIsOpen: _propTypes["default"].bool
  })
};